<template>
  <div
    v-show="modalVisible"
    class="sf-modal sf-modal-top sf-modal-s"
    @keyup.esc="toggleModal"
  >
    <div
      class="sf-modal-backdrop"
      data-testid="quick-search-backdrop"
      @click="toggleModal"
    ></div>
    <div
      v-if="modalVisible"
      class="sf-modal-container"
      data-testid="quick-search-container"
      @click.self="toggleModal"
    >
      <SearchForm :limit="limit" :should-focus-after-mount="true"></SearchForm>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import SearchForm from './search-form'

export default {
  name: 'SearchModal',
  components: {
    SearchForm,
  },

  props: {
    limit: {
      type: Number,
      default: 4,
    },
  },

  computed: {
    ...mapGetters(['modalVisible']),
  },

  methods: {
    ...mapActions(['toggleModal']),
  },
}
</script>
